import script from "./CollectionCardSelectCount.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionCardSelectCount.vue?vue&type=script&setup=true&lang=js"

import "./CollectionCardSelectCount.vue?vue&type=style&index=0&id=a09d903e&lang=scss"

const __exports__ = script;

export default __exports__